import React from 'react';
import capitalize from 'lodash/capitalize';
import { mergeSx } from '../../utils/sx/merge';
import { useTheme } from '../../hooks/useTheme';
import { Box } from '../box';
import { Typography } from '../typography';
import { StyledUnorderedList } from '../styled/styledUnorderedList';
import { StyledListItem } from '../styled/styledListItem';
import { Tag } from '../tag';
import { Link } from '../link';
import { TAG_LIST_COLLAPSED_COUNT } from '../tag/const';
import { TagCloudProps } from './types';
export type { TagCloudProps } from './types';

const MAX_VISIBLE_ITEMS_BY_DEFAULT = TAG_LIST_COLLAPSED_COUNT;

export const TagCloud: React.FC<TagCloudProps> = ({ title, items, maxVisibleItemsCountByDefault = MAX_VISIBLE_ITEMS_BY_DEFAULT, sx }) => {
  const theme = useTheme();
  const [isExpanded, setExpanded] = React.useState(false);

  return (
    <Box
      sx={mergeSx(
        {
          p: 3.75,
          border: `1px solid ${theme.palette['brand gray']}`,
          borderRadius: `${theme.borderRadius.extraLarge}px`,
          backgroundColor: 'white',
        },
        sx,
      )}
    >
      {Boolean(title) && (
        <Typography component="h3" sx={{ mt: 0, mb: 1.5 }} variant="h6 Bold">
          {title}
        </Typography>
      )}

      <StyledUnorderedList sx={{ mx: -0.75, display: 'flex', flexWrap: 'wrap' }}>
        {items.map(({ key, label, ...restItemProps }, index) => (
          <StyledListItem
            key={key}
            sx={{ my: 1, mx: 0.75, display: index >= maxVisibleItemsCountByDefault && !isExpanded ? 'none' : undefined }}
          >
            <Tag
              href={'href' in restItemProps ? restItemProps.href : undefined}
              onClick={'onClick' in restItemProps ? restItemProps.onClick : undefined}
            >
              {typeof label === 'string' ? capitalize(label) : label}
            </Tag>
          </StyledListItem>
        ))}
      </StyledUnorderedList>

      {!isExpanded && items.length > maxVisibleItemsCountByDefault && (
        <Link onClick={() => setExpanded(true)} sx={{ mt: 0.75, mx: 0.75, display: 'block' }}>
          Показать ещё
        </Link>
      )}
    </Box>
  );
};
